module.exports = __webpack_public_path__ + "HONDA-logo.png";